const {
  getDealCarteGrise,
  getFinanceSimulationCarteGrise,
} = require("./getDealCarteGrise");
const { VEHICLE_REGISTRATION_METHOD } = require("../../constants");

/**
 * Calculates carte grise amount
 * @param {Object} source - deal or financeSimulation object
 * @param {boolean} skipRegistrationTypeCheck - if true, skips current registration type check
 * @returns {number} carte grise amount
 */
function getCarteGriseAmount(
  source,
  skipRegistrationTypeCheck = false,
  isSourceDeal = true
) {
  const carteGrise = isSourceDeal
    ? getDealCarteGrise(source)
    : getFinanceSimulationCarteGrise(source);

  const { vehicleRegistration } = isSourceDeal
    ? source.financeSimulation
    : source;

  let isVehicleRegistrationCitroen = false;

  if (typeof vehicleRegistration === "string") {
    isVehicleRegistrationCitroen =
      vehicleRegistration === VEHICLE_REGISTRATION_METHOD.CITROEN;
  } else {
    isVehicleRegistrationCitroen =
      vehicleRegistration?.type === VEHICLE_REGISTRATION_METHOD.CITROEN ||
      vehicleRegistration?.method === VEHICLE_REGISTRATION_METHOD.CITROEN;
  }

  if (
    !carteGrise ||
    (!isVehicleRegistrationCitroen && !skipRegistrationTypeCheck)
  ) {
    return 0;
  }

  const sum =
    carteGrise.fixedTaxAmount +
    carteGrise.deliveryCost +
    carteGrise.registrationCost;

  if (isNaN(sum)) {
    return 0;
  }

  return sum;
}

module.exports = {
  getCarteGriseAmount,
};
